import { techLogos, techLogoOrder } from "./TechLogos.js";

function renderLogoTile(id) {
  const logo = techLogos[id];
  return `
    <div class="hero-logo-marquee__tile" style="--tile-accent: ${logo.accent}">
      <span class="hero-logo-marquee__icon">${logo.svg}</span>
    </div>
  `;
}

function buildLogoGroup(repeatCount) {
  return Array.from({ length: repeatCount }, () => techLogoOrder.map(renderLogoTile).join("")).join("");
}

export function createHeroLogoMarquee() {
  const wrap = document.createElement("div");
  wrap.className = "hero-logo-marquee";
  wrap.setAttribute("aria-hidden", "true");

  wrap.innerHTML = `
    <div class="hero-logo-marquee__glow"></div>
    <div class="hero-logo-marquee__viewport">
      <div class="hero-logo-marquee__track">
        <div class="hero-logo-marquee__group"></div>
        <div class="hero-logo-marquee__group" aria-hidden="true"></div>
      </div>
    </div>
  `;

  bindInfiniteMarquee(wrap);
  return wrap;
}

function bindInfiniteMarquee(wrap) {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const viewport = wrap.querySelector(".hero-logo-marquee__viewport");
  const track = wrap.querySelector(".hero-logo-marquee__track");
  const groups = [...wrap.querySelectorAll(".hero-logo-marquee__group")];

  const syncGroups = () => {
    if (reduced) {
      groups[0].innerHTML = buildLogoGroup(1);
      groups[1].innerHTML = "";
      track.style.removeProperty("--marquee-duration");
      return;
    }

    const minWidth = viewport.offsetWidth || 0;
    let repeats = 2;

    groups[0].innerHTML = buildLogoGroup(repeats);
    groups[1].innerHTML = groups[0].innerHTML;

    // Keep one group at least as wide as the viewport for a seamless -50% loop
    while (groups[0].offsetWidth < minWidth && repeats < 24) {
      repeats += 1;
      groups[0].innerHTML = buildLogoGroup(repeats);
      groups[1].innerHTML = groups[0].innerHTML;
    }

    const distance = groups[0].offsetWidth || minWidth || 1;
    const pixelsPerSecond = 72;
    const duration = `${Math.max(distance / pixelsPerSecond, 12)}s`;

    track.style.setProperty("--marquee-duration", duration);

    // Safari often keeps a stale animation when duration/content changes — restart it
    track.style.webkitAnimation = "none";
    track.style.animation = "none";
    void track.offsetWidth;
    track.style.webkitAnimation = "";
    track.style.animation = "";
  };

  // Defer first measure so Safari has laid out the flex track
  requestAnimationFrame(syncGroups);

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(syncGroups);
    observer.observe(viewport);
  } else {
    window.addEventListener("resize", syncGroups);
  }
}
